<div class="drawer-share-bar" *ngIf="data">
  <app-euds-button type="tertiary"
                   label="Copy Link"
                   icon="feather/copy"
                   iconPosition="left"
                   (clickEvent)="copyLink()"></app-euds-button>
  <div class="copy-status" *ngIf="copyStatus">{{copyStatus}}</div>
</div>
